export const stripHtmlTags = (htmlString: string | null | undefined): string => {
  if (!htmlString || typeof htmlString !== 'string') {
    return '';
  }
  return htmlString
    .replace(/<[^>]*>/g, '') // HTML 태그 제거
    .replace(/&nbsp;/g, ' ') // &nbsp;를 공백으로 변환
    .replace(/&amp;/g, '&') // &amp;를 &로 변환
    .replace(/&lt;/g, '<') // &lt;를 <로 변환
    .replace(/&gt;/g, '>') // &gt;를 >로 변환
    .replace(/&quot;/g, '"') // &quot;를 "로 변환
    .replace(/&#39;/g, "'") // &#39;를 '로 변환
    .trim(); // 앞뒤 공백 제거
};
